module.exports = __webpack_public_path__ + "static/media/bone1_Bitmap.3c84639c.png";